import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/filePersiapanPensiunService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "filePensiunTableActive";
  defaultOrder = "emp_retired_submission_date_start";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      submitUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      approveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          this.inactiveData();
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.activeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
    {
      key: "emp_retired_submission_date_start",
      text: "Periode",
      className: "emp_retired_submission_date_start",
      sortable: true,
      cell: (record) => {
        return reformatDate(record.emp_retired_submission_date_start);
      },
    },
    {
      key: "total_peserta",
      text: "Jumlah Penerima",
      className: "total_peserta",
      sortable: true,
      cell: (record) => {
        return record.total_peserta + " Orang";
      },
    },
    {
      key: "emp_retired_submission_status",
      text: "Status",
      className: "emp_retired_submission_status",
      sortable: true,
      cell: (record) => {
        //console.log('cek ', record)
        if (record.emp_retired_submission_status) {
          let status = parseInt(record.emp_retired_submission_status);
          if (status === 1) {
            status = (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                Selesai
              </label>
            );
          } else if (status === 2) {
            status = (
              <label className="badge rounded-pill bg-soft-danger font-size-12">
                Ditolak
              </label>
            );
          } else {
            status = (
              <label className="badge rounded-pill bg-soft-info font-size-12">
                Menunggu Proses
              </label>
            );
          }
          return <span> {status} </span>;
        }
        return (
          <label className="badge rounded-pill bg-soft-info font-size-12">
            Menunggu Proses
          </label>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.emp_retired_submission_id;
        let data_status = parseInt(record.emp_retired_submission_status);
        return (
          <Fragment>
            {accessRole("update") ? (
              <span>
                <button
                  className="btn btn-warning btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.emp_retired_submission_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-plus"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  Tambah Pegawai
                </Tooltip>
              </span>
            ) : null}

            {/* {accessRole("approve") && (
              <span>
                <button
                  className="btn btn-success btn-sm"
                  id={"approve-" + thisId}
                  onClick={() => {
                    this.setState({
                      approveUuid: record.emp_retired_submission_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-user-check"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["approve-" + thisId]}
                  target={"approve-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["approve-" + thisId]: !this.state["approve-" + thisId],
                    });
                  }}
                >
                  Selesaikan Proses
                </Tooltip>
              </span>
            )} */}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/file_persiapan_pensiun.html?pegawai&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}
        {this.state.approveUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/file_persiapan_pensiun.html?approveperiod&uuid=" +
              this.state.approveUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
